// Base configuration
const baseUrl = "https://proxy.fastrak.uk";
const STAR_IMAGE_URL = "https://store.brth.uk/fastrak/{rating}-stars.svg";

let reviewsData = [];
let swiperInstance = null;

// Fetch reviews data
async function fetchReviews() {
    const container = document.getElementById("fastrak_moto101-pc");
    if (!container) return;
    
    try {
        const response = await fetch(`${baseUrl}/moto101-reviews`);
        const result = await response.json();
        
        if (result.status === "OK" && result.data && result.data.length > 0) {
            reviewsData = result.data;
            container.style.display = "block";
            initSwiper();
        }
    } catch (error) {
        console.error("Error fetching reviews:", error);
    }
}

// Format date for display
function formatDate(dateString) {
    const date = new Date(dateString);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${months[date.getMonth()]} ${date.getFullYear()}`;
}

// Get star image based on rating
function getStarImage(rating) {
    return STAR_IMAGE_URL.replace("{rating}", Math.round(rating));
}

// Initialize Swiper carousel
function initSwiper() {
    const carousel = document.getElementById("fastrak_moto101-review-cards-carousel");
    if (!carousel) return;
    
    // Clear any existing slides
    carousel.innerHTML = "";
    
    // Add review slides
    const reviews = reviewsData.slice(0, 20);
    reviews.forEach(review => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        
        slide.innerHTML = `
            <div class="slide-content">
                <img class="review-stars" src="${getStarImage(review.rating)}" alt="${review.rating} stars">
                <div class="review-text">${review.review_text}</div>
                <div class="reviewer-info">
                    <span class="reviewer-name">${review.author_name}</span>
                    <span class="review-date">${formatDate(review.review_datetime_utc)}</span>
                </div>
            </div>
        `;
        
        carousel.appendChild(slide);
    });
    
    // Clean up existing swiper
    if (swiperInstance) {
        swiperInstance.destroy(true, true);
    }
    
    // Initialize Swiper
    swiperInstance = new Swiper(".mySwiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },
        breakpoints: {
            "@0.00": {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            "@0.75": {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            "@1.00": {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            "@1.50": {
                slidesPerView: 4,
                spaceBetween: 50,
            },
        },
    });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", fetchReviews);

// Fallback if DOMContentLoaded already fired
if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fetchReviews, 1);
}